import { defaultTheme, Icons } from '@agro-club/agroclub-shared'
import { IconWrapper, TooltipIcon } from 'views/components/TooltipIcons/TooltipIcons'

export const LogisticsAgentVerifiedIcon = ({
  isVerified,
  hintText,
  size = 'large',
}: {
  isVerified: boolean
  hintText: string
  size?: 'large' | 'small'
}) => {
  return (
    <TooltipIcon isVisible text={hintText}>
      <IconWrapper $iconColor={isVerified ? defaultTheme.color.primary600 : undefined} size={size}>
        <Icons.IconContract />
      </IconWrapper>
    </TooltipIcon>
  )
}
